// 合同搜索输入框数据内容所属类型
// const compactSearchInputTypes = ['客户名称', '业务员', '合同编号', '备注'];
export const COMPACT_SEARCH_INPUT_OPTIONS = [
  {
    label: '客户名称',
    value: 'customerName',
  },
  {
    label: '客户编号',
    value: 'customerNo',
  },
  {
    label: '合同编号',
    value: 'contractNo',
  },
  {
    label: '业务员',
    value: 'salesmanName',
  },
  {
    label: '备注',
    value: 'remarks',
  },
];

export const a = 1;
